import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";
import type { ContractPaymentMethod } from "../types";

export function usePaymentMethodsService(contractId: string | number | undefined) {
  return useQuery<ContractPaymentMethod[]>({
    queryKey: ["contract-payment-methods", String(contractId)],
    queryFn: async () => {
      const res = await axiosInstance().get(
        `/customer/contracts/${contractId}/payment-methods`
      );
      return res.data?.data ?? res.data ?? [];
    },
    enabled: !!contractId,
  });
}
